





























import { Rarity } from '@/bindings/Rarity'
import { Result } from '@/types/Result'
import { Character } from '@/bindings/Character'
import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            saveResults: false,
            Rarity: Rarity,
            highestRarityCookie: -1,
            highestRaritySoulstone: -1,
            epic: Math.random(),
            randomBool1: Math.random() < 0.5,
            randomBool2: Math.random() < 0.5,
            showVideo: true,
            result: JSON.parse(this.$route.query.result as string) as Result || new Result()
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name == "Standard") (vm as any).saveResults = true;
            next();
        })
    },
    mounted() {

        for (const cookie of this.result.cookies) {
            // if you get a cookie then the amount of soulstones you get are 20, 'this.store' saves these results to the vue store plugin
            if (this.saveResults) this.$store.commit('addSoulstones', {name: cookie.name, soulstones: 20});
            //end

            // find highest rarity cookie (varying animations will be played depending on this)
            if (cookie.rarity && cookie.rarity > this.highestRarityCookie) {
                this.highestRarityCookie = cookie.rarity
            }
            //end
        }
        for (const soulstone of this.result.soulstones) {
            //if you get a soulstone then soulstone number is 1, 'this.store' saves these results to the vue store plugin
            if (this.saveResults) this.$store.commit('addSoulstones', {name: soulstone.name, soulstones: 1});
            //end 

            // same thing but for soulstones
            if (soulstone.rarity && soulstone.rarity > this.highestRaritySoulstone) {
                this.highestRaritySoulstone = soulstone.rarity
            }
            //end
        }
        console.log(JSON.parse(this.$route.query.result as string))
    }
})
